'use strict';

/* global $ */

import AudioMotionAnalyzer from 'modules/analyzer/audioMotion-analyzer';
import Bowser from 'modules/bowser/bowser';
import Hls from 'modules/hls/hls.light';


function Player(options) {

    let opt = $.extend({
        button: options.selector+'__button',
        volume: options.selector+'__volume',
        mute: options.selector+'__mute',
        artist: options.selector+'__artist',
        title: options.selector+'__title',
        time: options.selector+'__time',
        clipboard: options.selector+'__clipboard',
        browser: Bowser.getParser(window.navigator.userAgent)
    }, options);

    let statusStrings = {
        play: 'Играет сейчас',
        pause: 'Поток на паузе'
    };

    function initBlock(el) {
        console.log('[ Player/Init ]');
        let store = JSON.parse(localStorage.getItem('radiobox')) || {};
        let $el = $(el);
        let intervalId = null;

        /*
        if (!intervalId) {
            getCurrentTrack(opt);
            intervalId = setInterval(() => {
                getCurrentTrack(opt);
            }, 5000);
        }
        */

        let canvas = document.getElementById('audioCanvas');
        let audioMotion = null;
        if (canvas) {
            audioMotion = new AudioMotionAnalyzer(
                canvas,
                {
                    //source: audio,
                    alphaBars: true,
                    bgAlpha: 1,
                    //gradient: 'steelblue',
                    gradient: 'classic',
                    //ledBars: true,
                    //loRes: true,
                    mode: 8,
                    overlay: true,
                    minFreq: 20,
                    maxFreq: 20000,
                    frequencyScale: 'log',
                    weightingFilter: 'D',
                    minDecibels: -80,
                    maxDecibels: -25,
                    reflexAlpha: 1,
                    reflexRatio: 0.5,
                    reflexBright: 0.8,
                    showBgColor: false,
                    showPeaks: false,
                    showScaleX: false,
                    smoothing: 0.3,
                    // set your preferred options here
                }
            );
            /*
            $('#audioCanvas').on('click', function() {
                if ($el.hasClass('is-played')) {
                    audioMotion.toggleFullscreen();
                }
            });
            */
        }

        let hls = 0;
        let hlsObject = null;
        let id = $el.attr('data-id');
        let stream = $el.attr('data-stream');
        let audio = document.getElementById('audio');
        audio.addEventListener('canplay', function(e) {
            hls = 0;
            if (!audioMotion._sources.length) audioMotion.connectInput(audio);
        });
        audio.addEventListener('error', function(e) {
            console.log(e.target.error.code);
            hls = 1;
            if (!audioMotion._sources.length) audioMotion.connectInput(video);
        });
        let video = document.getElementById('video');
        audio.crossOrigin = 'anonymous';
        audio.src = stream;
        audio.load();

        //var player = new Playerjs({ id: 'player', file: stream });
        //var jsmediatags = window.jsmediatags;
        //jsmediatags.Config.setDisallowedXhrHeaders(['Access-Control-Allow-Headers', 'Access-Control-Expose-Headers']);
        /*
        jsmediatags.read(stream, {
            onSuccess: function(tag) {
                console.log(tag);
            },
            onError: function(error) {
                console.log(error);
            }
        });
        */
        /*
        audio.onloadedmetadata = (event) => {
            console.log(event);
        };
        */

        $el.find(opt.volume).on('input', function(e) {
            let volume = $(this).val() / 100;
            //console.log('[ Player/Change volume ]', volume);
            audio.volume = volume;
            $el.find(opt.mute).removeClass('m--muted m--25 m--50 m--75 m--100');
            if (volume == 0) {
                $el.find(opt.mute).addClass('m--muted');
            } else if (volume < 0.25) {
                $el.find(opt.mute).addClass('m--25');
            } else if (volume >= 0.25 && volume < 0.5) {
                $el.find(opt.mute).addClass('m--50');
            } else if (volume >= 0.5 && volume < 0.75) {
                $el.find(opt.mute).addClass('m--75');
            } else if (volume >= 0.75) {
                $el.find(opt.mute).addClass('m--100');
            }
        });
        $el.find(opt.volume).val(75).trigger('input');

        $el.find(opt.mute).on('click', function(e) {
            e.preventDefault();
            console.log('[ Player/Toggle mute ]');
            if ($(this).hasClass('m--muted')) {
                $(this).removeClass('m--muted');
                $el.find(opt.volume).trigger('input');
                audio.muted = false;
            } else {
                $el.find(opt.mute).removeClass('m--25 m--50 m--75 m--100');
                $(this).addClass('m--muted');
                audio.muted = true;
            }
        });

        console.log($el.find(opt.button));

        $el.find(opt.button).on('click', function(e) {
            e.preventDefault();
            /*
            if (context) {
                context.resume().then(() => {
                    console.log('Playback resumed successfully');
                });
            }
            */
            console.log('[ Player/Toggle play ]', hls);
            if ($(this).find('.icon').hasClass('m--play')) {
                $(this).find('.icon').removeClass('m--play').addClass('m--pause');
                $(this).find('span:not(.icon)').text('Пауза');
                $el.addClass('is-played');
                $el.find(opt.title).text(statusStrings.play);
                stream = $el.attr('data-stream');
                //audio.src = stream;
                //audio.load();
                //audio.play();
                //audio.muted = false;

                if (hls === 0) {
                    audio.src = stream;
                    audio.load();
                    audio.play();
                    audio.muted = false;
                } else {
                    if (Hls.isSupported()) {
                        if (!hlsObject) {
                            hlsObject = new Hls();
                            hlsObject.on(Hls.Events.MEDIA_ATTACHED, () => {
                                hlsObject.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
                                    console.log("manifest loaded, found " + data.levels.length + " quality level");
                                    video.play();
                                });
                                hlsObject.loadSource(stream);
                            });
                            hlsObject.attachMedia(video);
                        }
                    } else {
                        console.log('Not support');
                    }
                }
                
                //player.api('play');
                store.play = id;
            } else {
                $(this).find('.icon').removeClass('m--pause').addClass('m--play');
                $(this).find('span:not(.icon)').text('Слушать');
                $el.removeClass('is-played');
                $el.find(opt.title).text(statusStrings.pause);
                //player.api('stop');
                
                if (hls === 0) {
                    audio.pause();
                } else {
                    if (hlsObject) {
                        hlsObject.destroy();
                        hlsObject = null;
                    }
                }
                
                store.play = null;
            }
            localStorage.setItem('radiobox', JSON.stringify(store));
        });

        if (store.play && $el.find(opt.button).find('.icon').hasClass('m--play')) {
            PlayMusic();
            /*
            $('body').on('click', function(e) {
                e.preventDefault();
                console.log('BLA 1');
                $el.find(opt.button).click();
                $('body').off('click');
            });
            */
        }

        function PlayMusic() {
            console.log(opt.browser.getBrowserName());
            if (opt.browser.getBrowserName() === 'Chrome') $el.find(opt.button).click();
        }
    }

    $(opt.selector).each(function() {
        initBlock(this);
    });
}

export {
    Player
};
